import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { FINANCE, INDIVIDUAL } from '@rma/generic/domain/types';
import { ErrorService } from '@rma/public/generic/fallback-pages';
import { ProfileService, ProfileSummary } from '@rma/public/profiles/private/domain';
import { catchError, EMPTY } from 'rxjs';

export const mortgageBrokerProfileResolver = (route: ActivatedRouteSnapshot, s: RouterStateSnapshot) => {
  const router = inject(Router);
  const errorService = inject(ErrorService);
  const profileApi = inject(ProfileService);
  const paramName = 'profile-name';

  if (route.paramMap.has(paramName)) {
    const code = route.paramMap.get(paramName)?.split('-').pop();

    if (code) {
      return profileApi.getProfile(FINANCE, INDIVIDUAL, code).pipe(catchError((e) => errorService.handleError<ProfileSummary>(s.url, e)));
    }
  }

  router.navigateByUrl('/not-found');
  return EMPTY;
};
